import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=2b20a2f2&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"
import style0 from "./downloadApp.vue?vue&type=style&index=0&id=2b20a2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20a2f2",
  null
  
)

export default component.exports